import { z } from 'zod';
import { AppFramework, EnvKind, Platform, ProviderKind } from '@hangar/shared';
import { str, nstr } from './schemaPrimitives';

export const Warning = z.object({
  code: str,
  severity: z.enum(['info', 'warning', 'error']).catch('warning'),
  message: str,
  key: nstr,
  platform: nstr,
  field: nstr,
});
export type Warning = z.infer<typeof Warning>;

export const CheckStatus = z.enum(['passed', 'failed', 'warning', 'skipped', 'error']);
export type CheckStatus = z.infer<typeof CheckStatus>;

export const CheckResult = z.object({ key: str, status: CheckStatus.catch('warning'), blocking: z.boolean().default(false), message: nstr, details: z.record(str, z.unknown()).optional() });
export type CheckResult = z.infer<typeof CheckResult>;

export const Actor = z.object({ type: str, id: nstr, label: str });
export const UserSummary = z.object({ id: str, email: str, name: nstr, isExternal: z.boolean().optional() });
export const AppSummary = z.object({ id: str, slug: str, name: str, framework: AppFramework.catch('expo'), projectId: str });
export const EnvironmentSummary = z.object({ id: str, slug: str, name: str.optional(), kind: EnvKind.catch('staging'), color: nstr, isProtected: z.boolean().optional() });
export type EnvironmentSummary = z.infer<typeof EnvironmentSummary>;
export const ProfileSummary = z.object({ id: str, slug: str, name: str.optional(), platform: Platform });
export const ProviderAccountSummary = z.object({ id: str, kind: ProviderKind.catch('eas'), name: str });
export const GitRef = z.object({ branch: nstr, commitSha: nstr, commitMessage: nstr });
export const ErrorInfo = z.object({ category: str, code: str, message: str });

export const ClientExecutionPublic = z.object({
  attachDeadline: str,
  provider: str.optional(),
  easProfile: nstr,
  workingDirectory: nstr,
  command: nstr,
  // `runtimeToken` is deliberately not modelled: the console never reads or renders it.
});
